// extracted by mini-css-extract-plugin
export default {"search":"Search_search__ZEOLn","search__icon":"Search_search__icon__csLzu"};